import React from 'react'

import { Chip } from '@Components/Chips/Chip/Chip'
import { Element } from '@Components/Elements/Types'
import { Link } from '@Components/Link'
import { getLinkFromReference } from '@Globals/CMS/FieldHelpers'

export const ElementLabel = ({
  appearance,
  disableLinks = false,
  reference,
  text,
}: Extract<Element, { __typename: 'ElementLabel' }> & {
  disableLinks?: boolean
}) => {
  const link = getLinkFromReference(reference)
  const textWithFallback = text || link?.text || ''

  const content = (
    <Chip
      backgroundColor={appearance?.backgroundColor || 'rgba(21, 26, 28, 0.3)'}
      // TODO: clean up legacy hack where wordbook text is used as override for svgs
      color={textWithFallback.toLowerCase()}
      size="large"
      style={{
        fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
      }}
      textColor={appearance?.textColor || 'var(--white)'}
    >
      {textWithFallback}
    </Chip>
  )

  if (disableLinks || !link?.url) {
    return content
  }

  return (
    <Link
      analytics={{
        dest_page_type: link.type,
        dest_page_type_id: link.id || '',
      }}
      href={link.url}
    >
      {content}
    </Link>
  )
}
